import { inject, Injectable } from '@angular/core'
import { ReplaySubject } from 'rxjs'

import { first } from '@app/core/rxjs/first'
import { HttpService } from '@app/modules/http/services/http.service'

// StorageService seems to not work correctly
class SafeStorage {
  constructor(private readonly key: string) {}

  get(): any {
    try {
      return JSON.parse(localStorage.getItem(this.key)!)
    } catch {
      return null
    }
  }

  set(value: Record<any, any>): void {
    try {
      localStorage.setItem(this.key, JSON.stringify(value))
    } catch {}
  }

  delete(): void {
    try {
      localStorage.removeItem(this.key)
    } catch {}
  }
}

const shiftSignupLogs = () => {
  const SIGNUP_LS_KEY = 'ls.sb-1984'
  try {
    const logs = localStorage.getItem(SIGNUP_LS_KEY)
    if (logs) {
      localStorage.removeItem(SIGNUP_LS_KEY)
      return JSON.parse(JSON.parse(logs))
    }
  } catch {}

  return {}
}

@Injectable({
  providedIn: 'root',
})
export class OrwellService {
  private readonly httpService = inject(HttpService)

  private readonly initialized = new ReplaySubject<void>(1)
  private readonly persistedLog = new SafeStorage('sb-1984-log')
  logger: Record<string, string[]> = {}

  constructor() {
    this.logBatch(shiftSignupLogs())
    this.logBatch(this.persistedLog.get() || {})
    this.persist()
    this.initialized.next()
  }

  log(name: string, keyLog: string[]) {
    if (!this.logger[name]) {
      this.logger[name] = []
    }
    this.logger[name].push(...keyLog)
    this.persist()
  }

  async submit(): Promise<void> {
    await first(this.initialized)
    const print: Record<string, string> = this.prepareValues()

    if (Object.keys(print).length > 0) {
      const anyValues = Object.keys(print).reduce((acc, key) => acc || !!print[key], false)
      if (anyValues) {
        await this.httpService.postUrl('profile/orwell', { log: JSON.stringify(print) })
        this.persistedLog.delete()
      }
    }
  }

  private prepareValues(): Record<string, string> {
    return Object.keys(this.logger).reduce((acc, key: string) => {
      const value = this.logger[key].join('')
      this.logger[key].length = 0
      return { ...acc, [key]: value }
    }, {})
  }

  private persist(): void {
    void this.persistedLog.set(this.logger)
  }

  private logBatch(data: Record<string, string[]> = {}): void {
    Object.keys(data).forEach((key: string) => {
      this.logger[key] = this.logger[key] || []
      this.logger[key] = [...this.logger[key], ...data[key]]
    })
  }
}
